import { ModifyARRequest } from '@aiwyn/gql-api/src/models/request/modifyar-request.model';
import { ArTranType, CreateArTranPayload, InferredArTranLink } from '@anduin/api';
import { Observable } from 'rxjs';
import { NewTransactionOption, TransactionsSidebarMode, TransactionsTableExternalFilters } from '../models';
import { ArManagementFeatureStateContext } from './ar-management.model';

export class ApplyTransactionsFeatureStateStash {
  static readonly type = '[ArManagementState] ApplyTransactionsFeatureStateStash';
  constructor(public stashName: string) {}
}

export class SetTransactionsFeatureStateContext {
  static readonly type = '[ArManagementState] SetTransactionsFeatureStateContext';
  constructor(public context$: Observable<ArManagementFeatureStateContext>) {}
}

export class SetTransactionsFeatureStateStash {
  static readonly type = '[ArManagementState] SetTransactionsFeatureStateStash';
  constructor(public stashName: string) {}
}

export class ClearTransactionsFeatureStateStash {
  static readonly type = '[ArManagementState] ClearTransactionsFeatureStateStash';
  constructor(public stashName: string) {}
}

export class UpdateTransactionsTableExternalFilters {
  static readonly type = '[ArManagementState] UpdateTransactionsTableExternalFilters';
  constructor(public transactionsTableExternalFiltersPartial: Partial<TransactionsTableExternalFilters>) {}
}

export class SetTransactionsSidebarMode {
  static readonly type = '[ArManagementState] SetTransactionsSidebarMode';
  constructor(public transactionsSidebarMode: TransactionsSidebarMode) {}
}

export class GetArTranLabels {
  static readonly type = '[ArManagementState] GetArTranLabels';
  constructor(public forceRefresh = false) {}
}

export class SetSelectedNewTransactionOption {
  static readonly type = '[ArManagementState] SetSelectedNewTransactionOption';
  constructor(public newTransactionOption: NewTransactionOption) {}
}

export class SetAreTransactionSidebarChangesPending {
  static readonly type = '[ArManagementState] SetAreSidebarChangesPending';
  constructor(public areSidebarChangesPending: boolean) {}
}

export class GetUnallocatedArTranIds {
  static readonly type = '[ArManagementState] GetUnallocatedArTranIds';
  constructor(public forceRefresh?: boolean) {}
}

export class SelectArTran {
  static readonly type = '[ArManagementState] SelectArTran';
  constructor(public arTranId: number) {}
}

export class RefreshSelectedArTran {
  static readonly type = '[ArManagementState] RefreshSelectedArTran';

  constructor(public refreshLinkedArTrans = false) {}
}

export class DeselectArTran {
  static readonly type = '[ArManagementState] DeselectArTran';
}

export class SaveTransactionNote {
  static readonly type = '[ArManagementState] SaveTransactionNote';

  // use selected AR Tran if arTranId is not provided
  constructor(
    public note: string,
    public arTranId?: number,
  ) {}
}

export class SaveTransactionTotal {
  static readonly type = '[ArManagementState] SaveTransactionTotal';

  // use selected AR Tran if arTranId is not provided
  constructor(
    public total: number,
    public arTranId?: number,
  ) {}
}

export class GetLinkedArTrans {
  static readonly type = '[ArManagementState] GetLinkedArTrans';

  constructor(); // use selected AR Tran as core
  constructor(arTranIds: number[]); // IDs are already known but core is not selected (not sure when this is useful, but it's possible)
  constructor(arTranIds: number, coreArTranType: ArTranType); // IDs are just the core's id, so links are not known. Core AR Tran's type must be specified for lookup.
  constructor(
    public arTranIds?: number | number[],
    public coreArTranType?: ArTranType,
  ) {}
}

export class GetLinkableArTrans {
  static readonly type = '[ArManagementState] GetLinkableArTrans';

  constructor(public forceRefresh = false) {}
}

export class ClearLinkableArTrans {
  static readonly type = '[ArManagementState] ClearLinkableArTrans';
}

export class SaveTransactionLinks {
  static readonly type = '[ArManagementState] SaveTransactionLinks';

  constructor(
    public arTranId: number,
    public newTransactionLinks: InferredArTranLink[],
  ) {}
}

export class CreateTransaction {
  static readonly type = '[ArManagementState] CreateTransaction';

  constructor(public newTransaction: CreateArTranPayload) {}
}

export class DeactivateTransaction {
  static readonly type = '[ArManagementState] DeactivateTransaction';

  constructor(public transactionId: number) {}
}

export class SetPaymentAsNsf {
  static readonly type = '[ArManagementState] SetPaymentAsNsf';

  constructor(public transactionId: number) {}
}

export class UpdateTransaction {
  static readonly type = '[ArManagementState] UpdateTransaction';

  // use selected AR Tran if arTranId is not provided
  constructor(
    public updates: Partial<Omit<ModifyARRequest, 'id' | 'tenant' | 'allocations'>>,
    public arTranId?: number,
  ) {}
}
